import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyBMo5n9O_xCDO2W-d7rtJO4_f2yPEYCGWs',
  authDomain: 'tcaster-sobtid.firebaseapp.com',
  databaseURL: 'https://tcaster-sobtid.firebaseio.com',
  projectId: 'tcaster-sobtid',
  storageBucket: 'tcaster-sobtid.appspot.com',
  messagingSenderId: '803617612344',
  appId: '1:803617612344:web:0f046539666ec20bd3fccd',
  measurementId: 'G-QBQE2Z8LE2',
};

export const getFacebookProvider = () => new firebase.auth.FacebookAuthProvider();

// SHould change authDomain
//https://stackoverflow.com/questions/46135993/how-to-change-the-app-name-for-firebase-authentication-what-the-user-sees

export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();
